module.exports = __webpack_public_path__ + "media/images/emblems/Laconnex-coat_of_arms-586f21dd1a7f639d743510f7821f5d91.svg";